import { queryOptions } from '@tanstack/react-query';
import type { PaginationState } from '@tanstack/table-core';

import { DEFAULT_ODATA_PAGE_RESULT } from '@apple/utils/api/odata';

import { getEntries, search } from '../api/activity';
import type { ActivityLogEntityType, ActivityLogFiltersExtended } from '../models/activity';

export const activityLogQueryKeys = {
	all: ['activity-logs'],
	search: (pagination: PaginationState, filters: ActivityLogFiltersExtended) => [
		...activityLogQueryKeys.all,
		pagination,
		filters,
	],
	entries: (correlationId: string, entityType: ActivityLogEntityType, limit: number) => [
		...activityLogQueryKeys.all,
		correlationId,
		entityType,
		limit,
	],
} as const;

export const activityLogQueries = {
	search: (pagination: PaginationState, filters: ActivityLogFiltersExtended) =>
		queryOptions({
			queryKey: activityLogQueryKeys.search(pagination, filters),
			queryFn: ({ signal }) => search(pagination, filters, signal),
			initialData: DEFAULT_ODATA_PAGE_RESULT,
			initialDataUpdatedAt: 0,
			throwOnError: true,
		}),
	entries: (correlationId: string, entityType: ActivityLogEntityType, limit: number) =>
		queryOptions({
			queryKey: activityLogQueryKeys.entries(correlationId, entityType, limit),
			queryFn: ({ signal }) => getEntries(correlationId, entityType, limit, signal),
			staleTime: 60 * 1000,
			initialData: [],
			initialDataUpdatedAt: 0,
			throwOnError: true,
		}),
} as const;
